import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

function Header() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  const isActive = (path) => {
    return location.pathname === path ? 'active' : '';
  };

  return (
    <header className="site-header">
      <div className="header-container">
        <Link to="/" className="logo">
          <div className="logo-text">BUMTOOLBOX</div>
        </Link>
        
        <nav>
          <ul className="nav-menu">
            <li className="nav-item">
              <Link to="/" className={`nav-link ${isActive('/')}`}>ホーム</Link>
            </li>
            <li className="nav-item">
              <Link to="/character-counter" className={`nav-link ${isActive('/character-counter')}`}>文字数カウント</Link>
            </li>
            <li className="nav-item">
              <Link to="/png2pdf" className={`nav-link ${isActive('/png2pdf')}`}>PNG PDF変換</Link>
            </li>
            <li className="nav-item">
              <Link to="/thumbnail-downloader" className={`nav-link ${isActive('/thumbnail-downloader')}`}>YouTuberサムネイル</Link>
            </li>
          </ul>
        </nav>
        
        <button className="mobile-menu-toggle" onClick={toggleMobileMenu}>
          <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
            <path d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z"/>
          </svg>
        </button>
      </div>
      
      <nav className={`mobile-nav ${mobileMenuOpen ? 'open' : ''}`}>
        <ul className="mobile-nav-menu">
          <li className="mobile-nav-item">
            <Link to="/" className={`mobile-nav-link ${isActive('/')}`}>ホーム</Link>
          </li>
          <li className="mobile-nav-item">
            <Link to="/character-counter" className={`mobile-nav-link ${isActive('/character-counter')}`}>文字数カウント</Link>
          </li>
          <li className="mobile-nav-item">
            <Link to="/png2pdf" className={`mobile-nav-link ${isActive('/png2pdf')}`}>PNG PDF変換</Link>
          </li>
          <li className="mobile-nav-item">
            <Link to="/thumbnail-downloader" className={`mobile-nav-link ${isActive('/thumbnail-downloader')}`}>YouTuberサムネイル</Link>
          </li>
        </ul>
      </nav>
    </header>
  );
}

export default Header;

